

























































































































import Vue from 'vue';
import pjson from '../../../package.json'
import {mapActions, mapGetters} from 'vuex'

export default Vue.extend({
  data() {
    return {
      drawer: false,
      version: pjson.version,
      name: pjson.name
    }
  },
  computed: {
    ...mapGetters('activities', [
      'getUncheckedActivities'
    ]),
  },
  methods: {
    handleSignOutClick: function () {
      window.localStorage.removeItem('authToken')
      this.signOut()
    },
    ...mapActions({
      signOut: 'auth/signOut'
    })
  }
})
